import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';

import styled from '@emotion/styled';
import {setAuth} from '../../redux/actions/AuthActions';

import {loginUser} from '../../network';
import {decodeToken, saveTokenToLocalStorage} from '../../utils/auth';

const Button = styled.button`
    padding: var(--space-12) var(--space-32);
    font-size: var(--font-16);
    white-space: nowrap;
    color: var(--color-white);
    background: ${props => props.variantColor ? props.variantColor : 'gray'};
    box-shadow: ${props => props.variantShadow ? props.variantShadow : 'none'};
    border-radius: 2.75rem;
`;

const Layout = styled.div`
    display: grid;
    grid-auto-flow:column;
    align-items: center;
    justify-content: start;
    margin-top: 15vh;
    margin-bottom: 15vh;
    height: 100%;
    width: 100%;
    z-index:0;
`;

const CardWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 32rem;
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    width: 32rem;
    .create{
        width:10rem;
    }
    @media only screen and (max-width: 768px) {
    }
`;

const CardHeader = styled.h2`
    font-size: var(--font-32);
    font-weight: 500;
    width: 18.875rem;
    text-align: center;
    color: var(--company-dark);
    margin-bottom: var(--space-32);
    margin-top: var(--space-32);
`;

const CardInput = styled.input`
    height: var(--space-40);
    width: 100%;
    align-self: center;
    box-shadow: 0 0 0 1px var(--color-gray-300);
    background-color: var(--color-gray-100);
    text-indent: var(--space-12);
    border-radius: var(--space-8);
    margin-bottom: var(--space-24);
    &:last-of-type {
      margin-bottom: var(--space-32);
    }
    @media only screen and (max-width: 400px) {
    }
   
`;

const AccountBackground = styled.div`
    display: flex;
    position: absolute;
    
    width: 60vw;
    height: 30rem;
    left: -6rem;
    top: -12.5rem;
    background-image: url(/img/login_background.jpg);
    background-position-x: left;
    background-position-y: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-top-left-radius: var(--space-24);
    border-bottom-left-radius: var(--space-24);
    &:before {
        content: "";
        background-image: var(--image-gradient);
        width: 60vw;
        height: 100%;
        filter: opacity(0.85);
        border-top-left-radius: var(--space-24);
        border-bottom-left-radius: var(--space-24);
    }
`;

const HeaderText = styled.h1`
    position:relative;
    z-index:1;
    width: 26rem;
    line-height: var(--space-64);
    margin-top: -6rem;
    margin-bottom: var(--space-28);
    
    color:var(--color-white);
    font-size: var(--font-44);
`;

const SubText = styled.h3`
    position:relative;
    z-index:2;
    color:var(--color-white);
    font-size: var(--font-22);
`;

const TextLayout = styled.div`
    position: relative;
    
    font-size: 1.4rem;
    font-weight: 700;
`;

const SubLayout = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  font-size: var(--font-14);
  margin-bottom: var(--space-56);
  a {
    font-weight: 600;
    color: var(--color-blue-600);
  }
  span {
    display: flex;
    align-items: center;
    label {
      margin-left: var(--space-6);
      user-select: none;
      cursor: pointer;
    }
  }
`;

const BackofficeLogin = ({setAuth, setUser}) => {
    const history = useHistory();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSignIn = async (email, password) => {
        loginUser(email, password)
            .then(result => {
                let auth = {...result};
                if (auth.token) {
                    let userData = decodeToken(auth.token);
                    auth = {
                        ...auth,
                        ...userData
                    };
                }

                saveTokenToLocalStorage(auth);
                setAuth(auth);

                history.push('/backoffice/orders');
            })
            .catch(error => {
                // todo: show error on form
                setError('Username or Password is incorrect');
                console.error(error);
            });
    };

    return (
        <Layout>
            <CardWrapper>
                <CardContainer>
                    <CardHeader>Admin Sign In</CardHeader>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <CardInput placeholder="Email" type="email" onChange={(e) => setEmail(e.target.value.trim())} required></CardInput>
                        <CardInput placeholder="Password" type="password" onChange={(e) => setPassword(e.target.value.trim())} required></CardInput>
                        <SubLayout>
                            <Button variantColor="var(--hero-button)" variantShadow="var(--hero-button-shadow)" onClick={() => handleSignIn(email, password)}>Sign In</Button>
                        </SubLayout>
                    </form>
                    <span style={{
                        color: 'red',
                        marginTop: '1rem'
                    }}>{error}</span>
                </CardContainer>
            </CardWrapper>
            <TextLayout>
                <HeaderText>Medical Supplies for every situation</HeaderText>
                <SubText>We've got you covered</SubText>
                <AccountBackground role="img" aria-label="image of stethoscope"/>
            </TextLayout>
        </Layout>
    );
};

const mapDispatchToProps = {
    setAuth
};

export default connect(null, mapDispatchToProps)(BackofficeLogin);
